import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const Users = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const usersModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      title: 'Usuarios',
      auth: {
        roles: [ADMIN],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
